export default __webpack_public_path__ + "static/media/home.1c08e24e.svg";